import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import PartnerSectionWrapper from './partner.style';

const PartnerSection = ({
  row,
  col,
  title,
  description,
  button,
  author,
  textArea,
  imageArea,
  partnerImage
}) => {
  return (
    <PartnerSectionWrapper id="team">
      <Container>
        <Box {...row}>
          <Box {...col} {...imageArea} className="team_image">
            {/* Served from static/team/: 560 px for 1x screens, the 950 px
                original for retina. width/height keep the photo's proportions
                so the box is reserved before the file loads. The width spans
                the column with its 15 px gutters (capped at 560 px), the size
                the photo had when the old image service picked it from the
                column width. */}
            <img
              style={{width: 'calc(100% + 30px)', maxWidth: '560px', height: 'auto'}}
              src="/team/founder-560.webp"
              srcSet="/team/founder-560.webp 560w, /team/founder-950.webp 950w"
              sizes="(max-width: 590px) calc(100vw - 30px), 560px"
              width={950}
              height={841}
              loading="lazy"
              decoding="async"
              alt="Paweł Zubkiewicz"
            />
          </Box>
          <Box {...col} {...textArea} className="team_text">
            <Heading
              {...title}
              content="Hello. I'm Paweł 👋"
            />
            <Text
              {...description}
              fontSize={['18px', '20px']}
              fontWeight="700"
              color="#0f2137"
              mb="20px"
              content="Building CloudPouch since 2021"
            />
            <Text
              {...description}
              content={<>
              <a href="https://builder.aws.com/community/@pawelzubkiewicz" target='_blank'><b>AWS Hero</b></a>
              , architect & developer. Founder of the CloudPouch application.
              </>}
            />
            <Text
              {...description}
              content="CloudPouch started as the tool I needed for my own consulting work: one place to understand costs across the many AWS accounts I manage. It runs locally, so I can use it with client accounts without special permissions or juggling browser windows."
            />
            <Text
              {...description}
              content="Every day it shows me current usage, waste and misconfigured resources, so I can optimize costs for my clients."
            />
            <Text
              {...author}
              content={<>
              <a href="https://www.linkedin.com/in/pawelzubkiewicz/" target='_blank'><b><i>Paweł Zubkiewicz</i></b></a>
              </>}
            />
            <Text
              {...author}
              content="Founder."
            />
          </Box>
        </Box>
      </Container>
    </PartnerSectionWrapper>
  );
};

PartnerSection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  author: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
};

PartnerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  imageAreaRow: {
    flexDirection: 'row-reverse',
  },
  col: {
    pr: '15px',
    pl: '15px',
  },
  textArea: {
    width: ['100%', '100%', '55%', '50%', '38%'],
    pl: ['15px', '15px', '48px', '48px', '48px'],
  },
  imageArea: {
    width: ['100%', '100%', '45%', '50%', '56%'],
    mb: ['40px', '40px', '0', '0', '0'],
  },
  title: {
    fontSize: ['26px', '30px', '30px', '48px', '48px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '15px',
    lineHeight: '1.25',
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '33px',
  },
  author: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '0px',
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
    minWidth: '150px',
  },
  partnerImage: {
    maxWidth: '560px',
  }
};

export default PartnerSection;
